import { paths } from 'routes/paths';
import { Flow } from 'screens/Applications&WorkOrders/RouteAdmin';
import { OperationType } from 'components/RecordsListView/constants';
import showCropSeasonMismatchModal from 'helpers/showCropSeasonMismatchModal';
import {
  getSelectedCropSeasonIds,
  shouldShowRecommendationCropSeasonMismatch
} from 'helpers/cropSeasonMismatch';

export const shouldShowCropSeasonMismatch = (
  recommendation,
  selectedCropSeasonIds = []
) =>
  shouldShowRecommendationCropSeasonMismatch(
    recommendation,
    selectedCropSeasonIds
  );

export const createRecommendationOperationInitFlow = ({
  history,
  recommendation,
  operationType
}) => {
  return () => {
    history.push(
      `${
        operationType === OperationType.WORK_ORDER
          ? paths.workOrders
          : paths.applications
      }/create`,
      {
        flow: Flow.FROM_RECOMMENDATION_TO_OPERATION,
        targetOperation: operationType,
        recommendation
      }
    );
  };
};

const createOperationFromRecommendation = ({
  history,
  recommendation,
  operationType
}) => {
  if (
    !recommendation ||
    operationType === undefined ||
    operationType === null
  ) {
    return;
  }

  const initFlow = createRecommendationOperationInitFlow({
    history,
    recommendation,
    operationType
  });
  const selectedCropSeasonIds = getSelectedCropSeasonIds();

  if (shouldShowCropSeasonMismatch(recommendation, selectedCropSeasonIds)) {
    showCropSeasonMismatchModal(initFlow, operationType);
    return;
  }

  initFlow();
};

export default createOperationFromRecommendation;
